import { useCallback, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { evHeroClick, evHeroImpression } from 'events/symphony';
import { track } from 'apis/amethyst';
import LandingPageImage from 'components/landing/LandingPageImage';
import LandingPageLink from 'components/landing/LandingPageLink';
import useMartyContext from 'hooks/useMartyContext';

import css from 'styles/components/search/searchInlineHero.scss';

const SearchInlineHero = ({
  layoutStyle,
  searchTerm = '',
  slotDetails,
  shouldLazyLoad = true,
  hydraHdSearchImages
}) => {

  const { src, link, alt, mobilesrc, tabletsrc, retina, mobileretina, tabletretina } = slotDetails;
  const { marketplace: { hasBannerAds }, testId } = useMartyContext();

  const linkSearchContext = useMemo(() => ({
    keyword: searchTerm
    // TODO selected filters seem to be mutated in the reducer, so our update logic won't work correctly when we include them
  }), [searchTerm]);

  const handleClick = useCallback(() => {
    track(() => ([
      evHeroClick, { slotName: 'search-results-1', heroCount: 1, slotIndex: 1, slotDetails, linkSearchContext }
    ]));
  }, [linkSearchContext, slotDetails]);

  useEffect(() => {
    track(() => ([
      evHeroImpression, { slotName: 'search-results-1', heroCount: 1, slotIndex: 1, slotDetails, linkSearchContext }
    ]));
  }, [linkSearchContext, searchTerm, slotDetails]);

  if (!hasBannerAds) {
    return null;
  }

  const imgProps = { mobilesrc, src, alt, tabletsrc, retina, mobileretina, tabletretina, shouldLazyLoad };
  return (
    <div className={cn(css.wrapper, layoutStyle, { [css.hasHdSearchImages]: hydraHdSearchImages })}>
      <LandingPageLink
        url={link}
        className={css.innerWrapper}
        onClick={handleClick}
        data-test-id={testId('searchInlineHero')}
      >
        <LandingPageImage {...imgProps} />
      </LandingPageLink>
    </div>
  );
};

SearchInlineHero.propTypes = {
  layoutStyle: PropTypes.string.isRequired
};

export default SearchInlineHero;
